import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Cuándo recibo el ebook?',
    a: 'Acceso inmediato luego de la compra.'
  }, {
    q: '¿Necesito experiencia previa?',
    a: 'No, es para principiantes.'
  }, {
    q: '¿Puedo verlo desde el celular?',
    a: 'Sí, en cualquier dispositivo.'
  }, {
    q: '¿Necesito equipamiento?',
    a: 'No, no necesitás ningún equipamiento especial.'
  }, {
    q: '¿Cuánto tiempo por día?',
    a: 'Solo 20 minutos por día.'
  }, {
    q: '¿Es para hombres y mujeres?',
    a: 'Sí, el programa está diseñado para todos.'
  }, {
    q: '¿Qué pasa si no tengo constancia?',
    a: 'Incluye sistemas y herramientas para ayudarte a mantener el hábito.'
  }, {
    q: '¿Puedo hacerlo si estoy fuera de estado?',
    a: 'Sí, empezás desde tu nivel actual y vas progresando.'
  }, {
    q: '¿Incluye alimentación?',
    a: 'Sí, tenés una guía de alimentación incluida como bono.'
  }, {
    q: '¿Voy a ver resultados?',
    a: 'Sí, si seguís el plan vas a notar cambios reales en 30 días.'
  }];
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-24 bg-gray-50" data-id="element-68">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-69">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-70">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-71">
            Preguntas Frecuentes
          </h2>
          <div className="w-24 h-1.5 bg-rose-500 mx-auto rounded-full" data-id="element-72" />
        </motion.div>

        <div className="space-y-3" data-id="element-73">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden" initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.04
          }} data-id="element-74">
                <button onClick={() => toggle(index)} className="w-full flex items-center justify-between gap-4 p-5 md:p-6 text-left cursor-pointer hover:bg-gray-50/50 transition-colors" aria-expanded={isOpen} data-id="element-75">
                  <h3 className="font-bold text-gray-900 text-base md:text-lg pr-2" data-id="element-76">
                    {faq.q}
                  </h3>
                  <motion.div animate={{
                rotate: isOpen ? 180 : 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} className="flex-shrink-0" data-id="element-77">
                    <ChevronDownIcon className="w-5 h-5 text-rose-500" data-id="element-78" />
                  </motion.div>
                </button>

                <AnimatePresence initial={false} data-id="element-79">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-80">
                      <div className="px-5 md:px-6 pb-5 md:pb-6 pt-0" data-id="element-81">
                        <div className="border-t border-gray-100 pt-4" data-id="element-82">
                          <p className="text-gray-600 leading-relaxed" data-id="element-83">
                            {faq.a}
                          </p>
                        </div>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}